import React, { useState, useEffect } from 'react';
import { Empty, Table, message, Card, Spin, Row, Col, Skeleton } from 'antd'; // Typography
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { useExcryptedNavigation, ExchangeCurrency } from '../Filters/FilterConditions';
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/ContactTable';
import { StaffIcon, AccountsIcon } from '../../../components/Icons/Icons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { FetchDealByEntity } from "../../../Api/Services/CommonApiService";
import { FetchContactByAccount, FetchContactByDeal, FetchContactDetails } from "../../../Api/Services/ContactApiService";
import AddContactPage from '../Pages/AddCloneContactPage'
import { getAllCustomFieldByCompanyAndEntity } from '../../../Api/Services/CustomeUIApiService';

// const { Text } = Typography;

const ContactTable = ({ UrlId, listingType, refreshTrigger, tabKey, listingValues, setSelectedKeys, disabledData2, queryAction, EntityType, displayData, page, NacTrigger, setNaCTrigger }) => {
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'contacts')?.customEntityId
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const dispatch = useDispatch();
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);
        return formattedDate
    }
    const [createPage, setCratePage] = useState()
    const [dataForDeal, setDataForDeal] = useState()
    const [sortedInfo, setSortedInfo] = useState()
    const history = useHistory();
    const [checkboxValues, setCheckboxValues] = useState()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const ViewDetailPage2 = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    // const [openPage, setOpenPage] = useState(Array(dealsList?.length).fill(false));
    const [contacts, setContacts] = useState()
    const contacttype = "CONTACT"
    // const handleOpenPageChange = (index) => {
    //     const newPopoverOpenStates = [...openPage];
    //     newPopoverOpenStates[index] = !newPopoverOpenStates[index];
    //     setOpenPage(newPopoverOpenStates);
    // };
    const createDeal = (Aid) => {
        setNaCTrigger("trigger")
        setCratePage("AccountPage")
        setDataForDeal({ AccountId: Aid })
    }
    async function getAllContacts(listingValue) {
        try {
            const SortedData = listingValue.sort((a, b) => b.contacts_id - a.contacts_id);
            const transformedData = await Promise.all(
                SortedData.map(async (item) => {
                    const transformedCustomFields = await Promise.all(
                        (item.customFieldValues ?? []).map(async (attr) => {
                            const fieldConfig = checkboxValues.find(field => field.id === attr.fieldId);
                            if (!fieldConfig) return attr;
                            let transformedValue = attr.value;
                            if (fieldConfig.fieldType === "Currency") {
                                const currecnyData = attr.value ? await ExchangeCurrency(Number(attr.value), ConvertRate) : null
                                transformedValue = currecnyData
                                    ? Number(currecnyData?.toFixed(CurencyDecimalPlace))
                                    : 0;
                            } else if (fieldConfig.fieldType === "Date") {
                                transformedValue = attr.value
                                    ? formatDate(attr.value, profile)
                                    : attr.value;
                            }
                            return {
                                ...attr,
                                value: transformedValue,
                            };
                        })
                    );
                    return {
                        ...item,
                        created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
                        modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
                        customFieldValues: transformedCustomFields,
                    };
                })
            );
            setContacts(transformedData)
        } catch (error) {
            message.error(error);
        }
    }
    async function getContactPersons(params) {
        try {
            const PersonArray = params.split(',').map(item => Number(item.trim()));
            const results = await Promise.all(
                PersonArray.map(async (PersonId) => {
                    const responseData = await FetchContactDetails(PersonId)
                    const Response = responseData.data
                    return { ...Response, DataPermission: { isPresent: responseData.allow } };
                })
            );
            setContacts(results);
        } catch (error) {
            message.error(error);
        }
    }
    async function AllContact(type, id) {
        if (type === "Account") {
            try {
                const response = await FetchContactByAccount(id)
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (type === "Deal") {
            try {
                const response = await FetchContactByDeal(id)
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (type === "Task") {
            try {
                const response = await FetchDealByEntity(id, "Contact")
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setStates({ ...states, selectedRowKeys, selectedRows });
            setSelectedKeys(selectedRowKeys)
        },
        getCheckboxProps: (record) => {
            const permission = record.SharingData
            if (record?.ContactDataForPermission?.approved_for !== "None") {
                return { disabled: true };
            }
            // Only apply permission checks for these actions
            if (["Update", "OwnerChange", "Delete", "Sharing"].includes(queryAction)) {
                if (queryAction === "Sharing") {
                    return { disabled: record.userId !== profile.userId };
                }
                if (!permission) return { disabled: false }; // Full access if no sharingPermission

                if (["Update", "OwnerChange"].includes(queryAction)) {
                    return { disabled: !permission.includes("Update") };
                }

                if (queryAction === "Delete") {
                    return { disabled: !permission.includes("Delete") };
                }

               // if (queryAction === "Sharing") {
                //     return { disabled: !permission.includes("Sharing") };
                // }
            }
            return { disabled: false };
        }
    };
    const handleTableChange = async (_, _1, sorter) => {
        setSortedInfo(sorter)
    }
    const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo, defaultCurrency);
    const usersTableData = generateUsersTableData(contacts, checkboxValues, defaultCurrency);
    async function getColumnConfig() {
        try {
            const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
            const allFields = [...allFieldsRaw].sort((a, b) => {
                if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
                    return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
                }
                return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            });
            const structure = allFields.reduce((acc, field) => {
                if (field.fieldVisible === 'No') return acc;
                if (field.fieldKey === "lastName") return acc;
                if (field.fieldType === "FileUpload") return acc;
                if (field.fieldType === "MultiFileUpload") return acc;
                if (field.fieldKey === "firstName") {
                    acc.push({
                        isChecked: true,
                        id: field.fieldId,
                        name: "Name",
                        entityId: field.entityId,
                        fieldKey: "name",
                        fieldType: field.fieldType,
                        dropdownId: field.dropdownId,
                        dropdownType: field.dropdownType,
                        customFieldType: field.customFieldType,
                    });
                    return acc;
                }
                acc.push({
                    isChecked: true,
                    id: field.fieldId,
                    name: field.fieldLabel,
                    entityId: field.entityId,
                    fieldKey: field.fieldKey,
                    fieldType: field.fieldType,
                    dropdownId: field.dropdownId,
                    dropdownType: field.dropdownType,
                    customFieldType: field.customFieldType,
                });
                return acc;
            }, []);
            structure.push(
                {
                    isChecked: true,
                    id: "contact_score",
                    name: "Contact Score",
                    entityId: null,
                    fieldKey: "contact_score",
                    fieldType: "Number",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "created_at",
                    name: "Created Date",
                    entityId: null,
                    fieldKey: "created_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "modified_at",
                    name: "Modified Date",
                    entityId: null,
                    fieldKey: "modified_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                }
            );
            setCheckboxValues(structure)
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (listingType === "Query") {
            getColumnConfig()
        }
    }, [listingType, listingValues])
    useEffect(() => {
        if (listingType === "Query" && checkboxValues.length) {
            getAllContacts(listingValues)
        }
    }, [checkboxValues])
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (listingType !== "Query" && page !== "Deal") {
                if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                    AllContact("Lead", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                    AllContact("Deal", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                    AllContact("Contact", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                    AllContact("Account", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
                    AllContact("Task", UrlId[1])
                }
            }
            if (page === "Deal") {
                if (displayData?.contact_person) {
                    getContactPersons(displayData?.contact_person)
                }
                else {
                    setContacts([])
                }
            }
        }
    }, [UrlId, NacTrigger, displayData, refreshTrigger, tabKey])
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    }; const LoadingCiolums = [
        {
            title: (
                <Skeleton
                    paragraph={{ rows: 1, width: '100%' }}
                    active
                    title={false}
                />
            ),
            dataIndex: 'name',
            key: 'name',
        },]
    return (
        <>
            {listingType === "Query" ?
                // <div className="full-width-table" style={{ width: "100%" }} >
                <div className='Listing-PagePadding' style={{ width: "100%" }}>
                    <Cards headless bodyStyle={{ borderRadius: '10px' }}>
                        <div className="table-bordered leaderboard-table table-responsive">
                            <Table
                                showSorterTooltip={false}
                                rowSelection={rowSelection}
                                dataSource={usersTableData}
                                columns={!contacts ? LoadingCiolums : dynamicColumns}
                                locale={{
                                    emptyText: !contacts ? (
                                        <TableSkeleton rows={5} />
                                    ) :
                                        contacts?.length === 0 && <Empty />
                                }}
                                onChange={handleTableChange}
                                pagination={{
                                    defaultPageSize: 5,
                                    total: usersTableData.length,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }} />
                        </div>
                    </Cards>
                </div > :
                <>
                    {(EntityType !== "Task" && page !== "Deal") ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginBottom: 15 }}>
                            <div className={disabledData2 ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                role="button"
                                tabIndex={0} title='Add Contact'
                                onClick={disabledData2 ? undefined : () => createDeal(displayData?.account_id)}
                                onKeyDown={(event) => {
                                    if (disabledData2 && (event.key === 'Enter' || event.key === ' ')) {
                                        createDeal(displayData?.account_id)
                                    }
                                }}
                                aria-label='phone'
                            > <FeatherIcon icon="plus-circle" className="text_iconspace" size={16} />Add Contact</div>
                        </div>
                        : <></>}
                    <Row gutter={30}>
                        {contacts ? (contacts?.length > 0 ?
                            contacts?.map((item, index) => {
                                return (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                                        <div key={index} style={{ marginBottom: 15 }}
                                            className={item.DataPermission.isPresent ? "Card-click" : "Card-disabled"}
                                            role="button"
                                            tabIndex={0}
                                            onClick={item.DataPermission.isPresent ? () => ViewDetailPage2(item?.contacts_id, contacttype) : undefined}
                                            onKeyDown={(event) => {
                                                if (item.DataPermission.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                                                    ViewDetailPage2(item?.contacts_id, contacttype)
                                                }
                                            }}
                                            aria-label='phone'
                                        >
                                            <Card className="DetailsTabCard">
                                                <div style={{ padding: 10 }}>
                                                    <div className='user-info_image' style={{ marginBottom: 5, display: "flex", alignItems: "center", minWidth: 0, }}
                                                    > {item?.contact_profile !== null && item?.contact_profile
                                                        !== undefined && item?.contact_profile !== "" ?
                                                        <figure>
                                                            <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.contact_profile} alt="" />
                                                        </figure>
                                                        :
                                                        <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                                            {item?.first_name?.slice(0, 1).toUpperCase()}
                                                        </span>
                                                        }
                                                        <figcaption style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            overflow: "hidden", // 👈 keeps ellipsis responsive
                                                        }}>
                                                            <div style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={`${item?.first_name} ${item?.last_name}`}>
                                                                {`${item?.first_name} ${item?.last_name}`}
                                                            </div>
                                                            <div style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={item?.email} className='entityemail'>
                                                                {item?.email}
                                                            </div>
                                                        </figcaption>
                                                    </div>
                                                    <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                        <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
                                                    </div>

                                                    <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                        <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
                                                        {(item?.mobile && item?.mobile !== "") ? item?.mobile : <span style={{ visibility: "hidden" }}>0</span>}
                                                    </div>
                                                    {UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK" ?
                                                        item?.account_id &&
                                                        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                            <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
                                                        </div>
                                                        : <></>}
                                                </div>
                                            </Card>
                                        </div >
                                    </Col>
                                )
                            }) :
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                <div style={{ padding: "10%" }}>
                                    <Empty />
                                </div>
                            </Col>
                        )
                            :
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                <div className="spin">
                                    <Spin />
                                </div>
                            </Col>
                        }</Row>
                </>
            }
            <AddContactPage UrlId={undefined} FromPage={createPage} setCratePage={setCratePage} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
        </>
    );
}
ContactTable.propTypes = {
    queryAction: PropTypes.string.isRequired,
    listingType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    listingValues: PropTypes.array.isRequired,
    setSelectedKeys: PropTypes.func.isRequired,
    disabledData2: PropTypes.bool.isRequired,
    EntityType: PropTypes.string.isRequired,
    displayData: PropTypes.object.isRequired,
    page: PropTypes.string.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(ContactTable)